import React from 'react';
import Slider, { Settings } from 'react-slick';
import PriceLink, { PriceLinkType } from '../card/price-link';
import FANextArrow from './components/fa-next-arrow';
import FAPrevArrow from './components/fa-prev-arrow';

interface PriceCarouselProps {
  priceUrls: PriceLinkType[];
}

const PriceCarousel: React.FC<PriceCarouselProps> = ({ priceUrls }) => {
  const settings: Settings = {
    className: 'state-slider px-2',
    infinite: false,
    centerMode: false,
    nextArrow: <FANextArrow />,
    prevArrow: <FAPrevArrow />,
    variableWidth: true,
    rows: 1,
    swipeToSlide: true,
  };

  if (!priceUrls.length) {
    return null;
  }

  return (
    <>
      <h3 className="search-title mb-0">Other available price listings</h3>
      <Slider
        {...settings}
      >
        {priceUrls.map((priceUrl) => (
          <PriceLink priceUrl={priceUrl} key={priceUrl.label} />
        ))}
      </Slider>
    </>
  );
};

export default PriceCarousel;
